import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const DELIVERY_PERMISSIONS = {
  READ: PERMISSIONS.CONTRACTS_READ,
};

export const DELIVERY_QUERY_KEYS = queryKeys.deliveries;

export const DELIVERY_STATUSES = ['CREATED', 'READY', 'DEPARTED', 'IN_TRANSIT', 'ARRIVED', 'RECEIVED'];
export const PREPARING_STATUSES = ['CREATED', 'READY'];
export const IN_TRANSIT_STATUSES = ['DEPARTED', 'IN_TRANSIT'];
export const RECEIPT_STATUSES = ['PENDING', 'ACCEPTED', 'PARTIAL', 'REJECTED'];
